// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"d92a1c90","247":"732d1ef0","422":"370ae027","627":"50383890","867":"6eb05f2c","923":"69ec2335","938":"88d0b45e"}[chunkId] + ".chunk.js";
};